(function(){
  var KEY='moyoni_wishlist';
  function read(){try{return JSON.parse(localStorage.getItem(KEY))||[]}catch(e){return []}}
  function write(a){try{localStorage.setItem(KEY,JSON.stringify(a))}catch(e){}}
  function has(h){return read().indexOf(h)>-1}
  function toggle(h){var a=read(),i=a.indexOf(h);if(i>-1)a.splice(i,1);else a.push(h);write(a);sync();
    document.dispatchEvent(new CustomEvent('moyoni:wishlist',{detail:{handle:h,added:i===-1}}));}
  var svg='<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M12 20.5 4.3 13.2a4.7 4.7 0 0 1 6.6-6.7l1.1 1.1 1.1-1.1a4.7 4.7 0 0 1 6.6 6.7z" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>';
  function btn(h,cls){
    var b=document.createElement('button');b.type='button';b.className='moyoni-heart '+(cls||'');b.setAttribute('data-handle',h);
    b.innerHTML=svg;b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();toggle(h)});return b;}
  function sync(){document.querySelectorAll('.moyoni-heart').forEach(function(b){
    var on=has(b.dataset.handle);b.classList.toggle('is-on',on);b.setAttribute('aria-pressed',on);
    b.setAttribute('aria-label',on?'Remove from wishlist':'Add to wishlist');});
    document.querySelectorAll('[data-moyoni-wl-count]').forEach(function(n){var c=read().length;n.textContent=c?c:'';});}
  function inject(root){
    (root||document).querySelectorAll('.card-wrapper:not([data-wl])').forEach(function(w){
      var a=w.querySelector('a[href*="/products/"]');if(!a)return;
      var m=a.getAttribute('href').match(/\/products\/([^?#\/]+)/);if(!m)return;
      w.setAttribute('data-wl','1');w.appendChild(btn(m[1],'moyoni-heart--card'));});
    var pt=document.querySelector('.product__title');var ph=document.querySelector('[data-moyoni-handle]');
    if(pt&&ph&&!document.querySelector('.moyoni-heart--pdp')){
      var b=btn(ph.getAttribute('data-moyoni-handle'),'moyoni-heart--pdp');pt.parentNode.insertBefore(b,pt.nextSibling);}
    sync();}
  document.addEventListener('DOMContentLoaded',function(){inject();
    new MutationObserver(function(){inject()}).observe(document.body,{childList:true,subtree:true});});
  window.MoyoniWishlist={read:read,toggle:toggle,has:has};
})();
